export const DEFAULT_ACCEPTED_FILE_TYPES =
    'image/*,application/pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv,.html,.docm,application/zip,application/x-zip-compressed,.DOC,.DOCX,.XLS,.XLSX,.PPT,.PPTX,.TXT,.CSV,.HTML,.DOCM';

export const DEFAULT_MIN_HEIGHT = '104px';

export const DEFAULT_MAX_HEIGHT = '240px';

export const DEFAULT_SPELLCHECK_DELAY = 1000;
